import { Injectable, Inject } from '@angular/core';
import { EventManagerPlugin } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';

@Injectable()
export class ScrollFixPlugin extends EventManagerPlugin {
  constructor(@Inject(DOCUMENT) doc: any) {
    super(doc);
  }

  // Este plugin solo se aplica a eventos de scroll/touch
  supports(eventName: string): boolean {
    return ['touchstart', 'touchmove', 'wheel'].includes(eventName);
  }

  addEventListener(element: HTMLElement, eventName: string, handler: Function): Function {
    const listener = (event: Event) => handler(event);

    element.addEventListener(eventName, listener, { passive: true });

    return () => {
      element.removeEventListener(eventName, listener, false);
    };
  }
}
